export default "__VITE_ASSET__ChAwRNRQ__"